import React,{useContext, useState} from 'react';

import './Puzzle.css';

import {Stage, Layer, Image as ImageKonva} from 'react-konva';
import {createPieces, isOrdered, tradePieces, updatePosition} from'./Pieces';
import {ImageLoader} from './ImageLoader';
import ModalWin from './modalWin/ModalWin';

import {ContextGame} from '../GameProvider';
import {ContextPlayer} from '../player/PlayerProvider';
import {ContextGlobal} from '../../globalProvider';

import {isMobile} from '../../Utils';


const  Puzzle = () => {
	
 	const {state, dispatch} = useContext(ContextGame);
	const player = useContext(ContextPlayer);
	const global = useContext(ContextGlobal); 

	const [windowSize, setWindowSize] = useState({width:0,height:0});
	const [startGame, setStartGame] = useState(false);
	const [win, setWin] = useState(false);

	const [pieces, setPieces] = useState();
	
	const [imageGame, setImageGame] = useState({image:new Image(), status:false, erro:""});
	const [imageButton, setImageButton] = useState({image:new Image(), status:false, erro:""});

	// The initial leyer handle the first window. The main layer handle the pieces of game 
	// And the temp handle the picked pieces
	const [stage, setStage] = useState();
	const [initLayer, setInitLayer] = useState(); 
	const [mainLayer, setMainLayer] = useState();
	const [tempLayer, setTempLayer] = useState();

	// Css control of the component visualisation in diffents devices
	const [mobile, setMobile] = useState(isMobile());
 	const styleDisplay = (!mobile)?{position:"inherit"}:(player.state.initGame)?{position:"inherit"}:{position:"fixed", left:"110vw"};

 	const handleWindowResize = (element, updateFunction) => {
		const handler =  (event) =>{
			try{
			   updateFunction({width:element.offsetWidth, height:element.offsetHeight});
			   setMobile(() => isMobile());
			   global.dispatch({type:"UpdateIsMobile", isMobile:isMobile()});

			}catch(erro){
				throw new Error("Check your element and updateFunction!");
			}
		};

		window.addEventListener("resize",handler, false);

		return () => window.removeEventListener("resize",handler, false);
	};

 	React.useEffect(() => {
 			const element = document.getElementsByClassName("puzzleContent")[0];

 		 	setWindowSize(()=>{return{width:element.offsetWidth, height:element.offsetHeight};});

 		 	ImageLoader('midias/images/games/puzzles/play.png', setImageButton).then(
 				(image) => {},
 				(erro) => setImageButton(() =>{ return {image:new Image(), status: false, erro:erro};})
 			);

 		 	return handleWindowResize(element, setWindowSize);
 		}, []);

 	React.useEffect(() => {
 			ImageLoader(state.games[state.id].pathImageGame, setImageGame).then(
 				(image) => {
 					setPieces(() => createPieces(state.level));
 					setStartGame(() => false);
 				},
 				(erro) => setImageGame(() => {return {image:new Image(), status: false, erro:erro};})
 			);
 			return;
 		}
 	, [state.games,state.id,state.level]);

 	//Events of init layer
 	const handleStart = (event) => {
    	setStartGame(() => true);
		player.dispatch({type:"UpdatePlaying"});
  	};

  	const handleOver = (event) => {
    	let element = event.target;

    	element.attrs.width = windowSize.width/2;
    	element.attrs.height = windowSize.height/2;

    	element.move({
	      	x: windowSize.width*1/4 - element.attrs.x,
	      	y: windowSize.height*1/4 - element.attrs.y
    	});
    	initLayer.draw();
  	}

  	const handleOut = (event) => {
    	let element = event.target;

    	element.attrs.width = windowSize.width/3;
    	element.attrs.height = windowSize.height/3;

    	element.move({
      		x: windowSize.width*1/3 - element.attrs.x,
      		y: windowSize.height*1/3 - element.attrs.y
    	});
    	initLayer.draw();
	}

	//Events of pieces
	const handleDragStart = (event) => {
    	event.target.moveTo(tempLayer);
    	mainLayer.draw();
  	}

  	const handleDragDrop = (event) => {
	    let target = event.target;

	    let intersectPiece = mainLayer.getIntersection(stage.getPointerPosition());

	    if(intersectPiece){
	    	setPieces(() => tradePieces([...pieces], intersectPiece, target));
	    	player.dispatch({type:"UpdateMoves"});
	    }

	    target = updatePosition(target, {width:windowSize.width/state.level, height: windowSize.height/state.level});
	    target.moveTo(mainLayer);

	    tempLayer.draw();
	    mainLayer.draw();

	    if(isOrdered(pieces)){
	    	player.dispatch({type:"UpdatePlaying"});
	      	if(state.games.length > state.id+1){
	      		dispatch({
                	type:"NextGame",
                	id:state.id+1
				});
				player.dispatch({type:"NewGame"});  

	      	}else{
	      		setWin(() => true);
	      	}
	    }
  	}

 	return (
		<div>
			<div className="puzzleContent colorEIC felx column centerItens" style={styleDisplay}>
				{(imageGame.status)?
					<Stage className="stage" ref={ele => setStage(() => ele)} width={windowSize.width} height={windowSize.height}>
						<Layer className = "mainLayer" ref = {layer => setMainLayer(() => layer)}>		
							{
								pieces.map((piece, index) => 
									<ImageKonva
										key = {index}
										id = {index}
						
										image = {imageGame.image}
						
										width = {windowSize.width/state.level}
										height = {windowSize.height/state.level}
						
										x = {windowSize.width/state.level*piece.x}
										y = {windowSize.height/state.level*piece.y}
						
										coorX = {piece.x}
										coorY = {piece.y}
						
										cropWidth = {imageGame.image.naturalWidth/state.level}
										cropHeight = {imageGame.image.naturalWidth/state.level}
						
										cropX = {imageGame.image.naturalWidth/state.level*piece.image.imageX}
										cropY = {imageGame.image.naturalWidth/state.level*piece.image.imageY}
						
										stroke="rgb(26,188,156)"

										draggable

										onDragStart = {handleDragStart}
										onDragEnd = {handleDragDrop}
									/>
								)
							}
						</Layer>
						<Layer ref = {layer => setTempLayer(() => layer)}></Layer>
						{
							(!startGame)?
								<Layer ref = {layer => setInitLayer(() => layer)}>
									<ImageKonva
										image = {imageGame.image}

										width = {windowSize.width}
										height = {windowSize.height}
									/>
									<ImageKonva
										image = {imageButton.image}

										width = {windowSize.width/3}
										height = {windowSize.height/3}

										x = {windowSize.width*1/3}
										y = {windowSize.height*1/3}

										duration = {3}

										onClick = {handleStart}
										ontouchend ={handleStart}

										onMouseover = {handleOver}
										ontouchstart = {handleOver}

										onMouseout = {handleOut}
									/>
								</Layer>:
									<Layer></Layer>
						}	 				
					</Stage>:
						(imageGame.erro)?
							<div></div>:
								<div></div>
				}	
			</div>
			<ModalWin visible = {win} />
    	</div>
 	);
 };

export default Puzzle;
